import { render, staticRenderFns } from "./participant_events.vue?vue&type=template&id=2fe3da86&"
import script from "./participant_events.vue?vue&type=script&lang=js&"
export * from "./participant_events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports